import Vue from "vue";
import Router from "vue-router";

import aIndex from "../views/adaptation/aIndex.vue";

import cIndex from "../views/configuration/cIndex.vue";

import fIndex from "../views/forecast/fIndex.vue";

import rIndex from "../views/recommend/rIndex.vue";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch(err => err)
// }
// const originalReplace = Router.prototype.replace
// Router.prototype.replace = function push(location) {
// 	return originalReplace.call(this, location).catch(err => err)
// }
Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    redirect: "/m-index/main",
    component: () => import("../views/menhu/index.vue"),
    meta: { title: "新高考" },
    children: [
      {
        path: "/login",
        component: () => import("../views/index.vue"),
        meta: { title: "系统首页" },
      },
      {
        path: "/m-index/main",
        component: () => import("../views/menhu/main.vue"),
      },
      {
        path: "/m-index/hld",
        component: () => import("../views/menhu/hld/hld.vue"),
      },
      {
        path: "/m-index/hld-result",
        component: () => import("../views/menhu/hld/result.vue"),
      },
      {
        path: "/m-index/inquiry",
        name: "inquiry",
        component: () => import("../views/menhu/inquiry/inquiry"),
        redirect: "/inquiryContent",
        children: [
          {
            path: "/inquiryContent",
            component: () => import("../views/menhu/inquiry/inquiryContent"),
          },
        ],
      },
      {
        path: "/m-index/adaptation",
        component: () => import("../views/menhu/adaptation/major"),
        redirect: "/major",
        children: [
          {
            path: "/major",
            component: () =>
              import("../views/menhu/adaptation/components/major.vue"),
            meta: {
              title: "adaptation",
            },
          },
          {
            path: "/zyinfo",
            component: () =>
              import("../views/menhu/adaptation/components/zyInfo.vue"),
            meta: {
              title: "adaptation",
            },
          },
          {
            path: "/schoollist",
            component: () =>
              import("../views/menhu/adaptation/components/schoolList.vue"),
            meta: {
              title: "adaptation",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/adaptation",
    component: aIndex,
    redirect: "/adaptation/subsystem",
    children: [
      {
        path: "/adaptation/personality",
        component: () => import("../views/adaptation/personality.vue"),
      },
      {
        path: "/adaptation/role",
        component: () => import("../views/adaptation/role.vue"),
      },
      {
        path: "/adaptation/subsystem",
        component: () => import("../views/adaptation/subsystem.vue"),
      },
      {
        path: "/adaptation/aHome",
        component: () => import("../views/adaptation/aHome.vue"),
      },
    ],
  },
  {
    path: "/configuration",
    component: cIndex,
    // redirect: '/configuration/school',
    children: [
      // {
      // 	path: '/configuration/school',
      // 	component: () => import('../views/configuration/school.vue')
      // },
      {
        path: "/configuration/major",
        component: () => import("../views/configuration/major.vue"),
      },
      // {
      // 	path: '/configuration/estimate',
      // 	component: () => import('../views/configuration/estimate.vue')
      // },
      // {
      // 	path: '/configuration/portrait',
      // 	component: () => import('../views/configuration/portrait.vue')
      // },
      // 专业信息路由
      {
        path: "/configuration/professionInfo",
        component: () => import("../views/configuration/ProfessionInfo.vue"),
      },
    ],
  },
  // 学校查询
  {
    path: "/configuration/school",
    component: () => import("../views/configuration/school.vue"),
  },
  //  高校排名
  {
    path: "/configuration/ranking",
    component: () => import("../views/configuration/ranking.vue"),
  },
  // 学科评估
  {
    path: "/configuration/estimate",
    component: () => import("../views/configuration/estimate.vue"),
  },
  // 专业画像
  {
    path: "/configuration/portrait",
    component: () => import("../views/configuration/portrait.vue"),
  },
  // 学校信息路由
  {
    path: "/configuration/schoolInfo/",
    component: () => import("../views/configuration/SchoolInfo.vue"),
    redirect: "/configuration/schoolInfo/schoolIndex",
    children: [
      // 学校首页路由
      {
        path: "schoolIndex",
        component: () => import("../views/configuration/SchoolIndex.vue"),
      },
      // 学校简介路由
      {
        path: "schoolBrief",
        component: () => import("../views/configuration/SchoolBrief.vue"),
      },
      // 学校院系设置路由
      {
        path: "schoolFaculty",
        component: () => import("../views/configuration/SchoolFaculty.vue"),
      },
    ],
  },
  {
    path: "/forecast",
    component: fIndex,
    children: [
      // {
      // 	path: '/forecast/query',
      // 	component: () => import('../views/forecast/query.vue')
      // },
      {
        path: "/configuration/major",
        component: () => import("../views/configuration/major.vue"),
      },
      {
        path: "/configuration/professionInfo",
        component: () => import("../views/configuration/ProfessionInfo.vue"),
      },
      // {
      // 	path: '/forecast/ProRank',
      // 	component: () => import('../views/forecast/ProRank.vue')
      // }
    ],
  },
  //学校就业查询
  {
    path: "/forecast/query",
    component: () => import("../views/forecast/query.vue"),
  },
  //专业就业查询
  {
    path: "/forecast/ProRank2",
    component: () => import("../views/forecast/ProRank2.vue"),
  },
  //专业就业查询(表格)
  {
    path: "/forecast/detail",
    component: () => import("../views/forecast/table.vue"),
  },
  //pdf下载
  {
    path: "/pdf",
    component: () => import("../views/forecast/pdf.vue"),
  },

  {
    path: "/recommend",
    component: rIndex,
    redirect: "/recommend/index",
    children: [
      // {
      // 	path: '/recommend/rank',
      // 	component: () => import('../views/recommend/rank.vue')
      // },
      // {
      // 	path: '/recommend/volunteer',
      // 	component: () => import('../views/recommend/volunteer.vue')
      // },
      //  {
      //      path: '/recommend/plan',
      //      component: () =>
      //          import ('../views/recommend/plan.vue')
      //  },
    ],
  },
  {
    path: "/recommend/index",
    component: () => import("../views/recommend/rIndex1.vue"),
  },
  {
    path: "/recommend/rank",
    component: () => import("../views/recommend/rank.vue"),
  },
  {
    path: "/recommend/volunteer",
    component: () => import("../views/recommend/volunteer.vue"),
  },
  {
    path: "/recommend/plan",
    component: () => import("../views/recommend/plan.vue"),
  },
];

const router = new Router({
  routes,
});

// //挂载路由导航守卫
// router.beforeEach((to, from, next) => {
// 	if (to.path === '/login' || to.path === '/findpwd' || to.path === '/school' || to.path === '/schinfo' || to.path ===
// 		'/bulletin')
// 		return next()
// 	// 获取token
// 	const tokenStr = window.sessionStorage.getItem('token')
// 	if (!tokenStr) return next('/login')
// 	next()
// })

export default router;
